import Link from "next/link";

const Banner = ({ data }) => {
  const isLargeImage = data.large_image && data.image.url;
  return (
    <Link
      aria-label={
        data.large_image?.alt || 
        data.image?.alt || 
        "Explore Ornaz Jewellery"
      }
      href={data.url}
      className={`
        block span-2 md:hidden xl:block 
        drop-shadow rounded-lg overflow-hidden
        ${!isLargeImage && "md:hidden lg:hidden xl:hidden"}
      `}
    >
      {(data.image || isLargeImage) && (
        <picture>
          {isLargeImage && (
            <source media="(min-width: 800px)" srcSet={data.large_image.url} />
          )}
          {data.image && (
            <source media="(max-width: 799px)" srcSet={data.image.url} />
          )}

          <img
            src={isLargeImage ? data.large_image.url : data.image.url}
            alt={isLargeImage ? data.large_image.alt : data.image.alt}
            width={'100%'}
            height={'auto'}
            loading="lazy"
            decoding="async"
            className="h-auto w-full"
          />

        </picture>
      )}
      {data.video && data.video.src && (
        <video
          loop
          muted
          playsInline
          autoPlay
          preload="none"
          width={'100%'}
          height={'auto'}
          poster={data.video.thumbnail_url}
          className="h-auto w-full"
        >
          <source src={data.video.src} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      )}
    </Link>
  );
};

export default Banner;
